module.exports = __webpack_public_path__ + "static/img/banner-home.306dd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryCenter/banner-home.png
// module id = WqrV
// module chunks = 44